// The standard Terms & Conditions are numbered 1-6. Quote-specific clauses are
// appended as section 7 onwards so the whole page reads as one document.
export const STANDARD_SECTION_COUNT = 6;

/**
 * Turn a flat, ordered clause list into headed groups.
 *
 * A clause with a blank sectionTitle continues the heading above it (that is
 * what the backend's help text promises staff), so groups are formed from
 * *consecutive* clauses sharing a title. A blank title on the very first
 * clause starts an untitled group, which the page labels generically.
 *
 * @param {Array<{id?: string, sectionTitle?: string, body?: string}>} terms
 * @returns {Array<{title: string, clauses: Array<object>}>}
 */
export const groupTermsByHeading = (terms) => {
  if (!Array.isArray(terms)) return [];

  return terms.reduce((groups, term) => {
    if (!term || !term.body) return groups;

    const title = (term.sectionTitle || "").trim();
    const current = groups[groups.length - 1];

    if (current && (title === "" || title === current.title)) {
      current.clauses.push(term);
    } else {
      groups.push({ title, clauses: [term] });
    }

    return groups;
  }, []);
};

export default groupTermsByHeading;
